/**
 * LP how-it-works synced carousels (sections/medispa-lp-how-it-works.liquid):
 * step images and step descriptions are two Swipers cross-controlled so they
 * move together. Loaded by deferred-scripts.liquid (marker: medispa-how-it-works).
 */
import { medispaCarousels, whenSwiperReady } from '@/components/utils/medispa-lp';

whenSwiperReady(() => {
  const imagesSlider = document.querySelector<HTMLElement>('.step-images.swiper');
  const contentSlider = document.querySelector<HTMLElement>('.step-descriptions.swiper');
  if (!imagesSlider || !contentSlider) return;

  const carousels = medispaCarousels();

  carousels['how-it-works-images'] = new window.Swiper(imagesSlider, {
    enabled: true,
    slidesPerView: 1.1,
    slidesPerGroup: 1,
    spaceBetween: 8,
    breakpoints: {
      550: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 'auto',
        allowTouchMove: false,
      },
    },
  });

  carousels['how-it-works-step-content'] = new window.Swiper(contentSlider, {
    enabled: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
      },
    },
  });

  carousels['how-it-works-images'].controller.control = carousels['how-it-works-step-content'];
  carousels['how-it-works-step-content'].controller.control = carousels['how-it-works-images'];
});
